// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"Loader-module__loader_wrapper--j5tdI"};